/**
 * 菜单
 */
class DZModelMenu{

    /**
     * 主键
     */
    id = "";

    /**
     * 菜单名称
     */
    name = "";

    /**
     * 菜单图标
     */
    icon = "";

    /**
     * 页面路径
     */
    path = "";

    /**
     * 父级ID
     */
    pid = "";

    /**
     * 排序，越大越靠前
     */
    sort = 0;

    /**
     * 子菜单
     */
    children: Array<DZModelMenu> = [];

    /**
     * 菜单类型（C菜单 B按钮）
     */
    menuType = "";

    /**
     * 权限标识符
     */
    perms = "";
}
export default DZModelMenu
